import React from "react";

function PendingSettlementsIcon({ fill = "#424242" }) {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6680_78033)">
        <rect
          y="-0.257812"
          width="51.3418"
          height="51.3418"
          rx="8.55696"
          fill="#FEF9C3"
        />
        <g clipPath="url(#clip1_6680_78033)">
          <path
            d="M26 35.5C20.21 35.5 15.5 30.79 15.5 25C15.5 19.21 20.21 14.5 26 14.5C31.79 14.5 36.5 19.21 36.5 25C36.5 30.79 31.79 35.5 26 35.5ZM26 16C21.035 16 17 20.035 17 25C17 29.965 21.035 34 26 34C30.965 34 35 29.965 35 25C35 20.035 30.965 16 26 16Z"
            fill="#854D0E"
          />
          <path
            d="M29 28.75C28.865 28.75 28.73 28.72 28.61 28.645L24.86 26.395C24.7494 26.3277 24.6582 26.2329 24.5951 26.1199C24.532 26.0069 24.4993 25.8794 24.5 25.75V19.75C24.5 19.33 24.83 19 25.25 19C25.67 19 26 19.33 26 19.75V25.33L29.39 27.355C29.5296 27.4406 29.6376 27.5694 29.6974 27.7218C29.7573 27.8742 29.7658 28.042 29.7217 28.1997C29.6776 28.3575 29.5833 28.4965 29.4531 28.5958C29.3228 28.6951 29.1638 28.7492 29 28.75Z"
            fill="#854D0E"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6680_78033">
          <rect
            width="51.3418"
            height="51.3418"
            fill="white"
            transform="translate(0 -0.257812)"
          />
        </clipPath>
        <clipPath id="clip1_6680_78033">
          <rect
            width="25.6709"
            height="25.6709"
            fill="white"
            transform="translate(12.8359 12.5781)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PendingSettlementsIcon;
